import { render } from "./MyBill.vue?vue&type=template&id=71d78f69&scoped=true&ts=true"
import script from "./MyBill.vue?vue&type=script&lang=ts"
export * from "./MyBill.vue?vue&type=script&lang=ts"

import "./MyBill.vue?vue&type=style&index=0&id=71d78f69&lang=css"
import "./MyBill.vue?vue&type=style&index=1&id=71d78f69&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d78f69"]])

export default __exports__